import Y, { useRef as _, useState as m, useMemo as I, useEffect as E } from "react";
import { m as $ } from "../../../libServer-S4LVM0ns.js";
import { defaultBreakpoints as k, breakpoints as H } from "./types.js";
function A(f, r) {
  const e = _(null), [p, x] = m("100%"), [s, C] = m(0), [g, w] = m(0), [W, P] = m(0), v = I(
    () => ({
      ...k,
      ...r.itemsPerBreakpoint
    }),
    [r.itemsPerBreakpoint]
  ), i = () => {
    e.current && (w(e.current.scrollWidth), P(e.current.clientWidth));
  }, a = I(
    () => ({
      shouldDisplayNext: s + W < g,
      shouldDisplayPrev: s > 0
    }),
    [s, W, g]
  );
  E(() => {
    const t = e.current;
    if (!t) return;
    const o = () => {
      const d = t.clientWidth ?? 0;
      let n = v.xs;
      for (const { size: y, key: h } of H)
        if (window.matchMedia(`(min-width: ${y}px)`).matches) {
          n = v[h] ?? k[h];
          break;
        }
      const u = getComputedStyle(t), B = parseInt(u.gap) || 0;
      let S = 0;
      if (r.paddingElementWrapper && t.children.length) {
        const y = t.children[0], h = t.children[t.children.length - 1], M = getComputedStyle(y), T = getComputedStyle(h);
        S = parseInt(M.paddingLeft) + parseInt(T.paddingRight);
      }
      const N = d - B - S, R = n.items + n.peek / 100, z = N / R;
      x(`${z}px`), i();
    };
    o(), i();
    const l = () => C(t.scrollLeft), c = $(() => {
      o(), i();
    }, 500);
    return t.addEventListener("scroll", l), window.addEventListener("resize", c), () => {
      t.removeEventListener("scroll", l), window.removeEventListener("resize", c);
    };
  }, [v, r.paddingElementWrapper, f]), E(i, [f]), E(() => {
    var t;
    (t = r.onNavigationStateChange) == null || t.call(r, a);
  }, [a, r]);
  const L = () => {
    e.current && e.current.scrollTo({
      left: Math.max(0, s - e.current.offsetWidth),
      behavior: "smooth"
    });
  }, b = () => {
    e.current && e.current.scrollTo({
      left: Math.min(g - W, s + e.current.offsetWidth),
      behavior: "smooth"
    });
  }, D = (t) => {
    if (!e.current) return parseInt(p);
    const o = Y.Children.count(f), l = {
      first: t === 0,
      last: t === o - 1
    }, c = () => {
      var u;
      if (!r.paddingElementWrapper) return 0;
      const d = (u = e.current) == null ? void 0 : u.children[t];
      if (!d) return 0;
      const n = getComputedStyle(d);
      return l.first ? parseInt(n.paddingLeft || "0") : l.last ? parseInt(n.paddingRight || "0") : 0;
    };
    return parseInt(p) + c();
  };
  return {
    carouselRef: e,
    shouldDisplayPrev: a.shouldDisplayPrev,
    shouldDisplayNext: a.shouldDisplayNext,
    scrollPrev: L,
    scrollNext: b,
    itemWidth: p,
    getItemWidth: D
  };
}
export {
  A as useCarousel
};
